export enum PricingCategoryCode {
  UNLIMITED = 'unlimited',
  SPECIAL = 'special',
  TIME_LIMITED = 'time_limited',
  WEEKEND_PASS = 'weekend_pass',
}

export const TAGS_SEPARATOR = ',';

export enum PlanCode {
  UNLIMITED_CLASS1 = 'unlimited_class1',
  // 필요시 추가
}

export enum LicenseType {
  CLASS1 = 'class1',
  CLASS2 = 'class2',
  // 필요시 추가
}

export interface PriceDto {
  id: number;
  planId: number;
  label: string;
  subLabel: string;
  licenseType: LicenseType;
  originPrice: number;
  price: number;
}

export interface PlanDto {
  id: number;
  code: PlanCode;
  label: string;
  subLabel: string;
  description?: string;
  repImagePath: string;
  tags: string; // 'best,new' 등 CSV
  sequence: number;
  prices: PriceDto[];
}

export interface CategoryDto {
  id: number;
  code: PricingCategoryCode;
  label: string;
  sequence: number;
  plans: PlanDto[];
}
